/**
 * Take a nested object and flatten it
 *
 * @param {Object} target
 * @param {String} delimiter
 *
 * @return {Object}
 */
export default function flatten (target, delimiter = '.') {
    let output = {};

    function step (object, prev) {
        Object.keys(object).forEach((key) => {
            let value = object[key];
            let type = Object.prototype.toString.call(value);
            let newKey = prev ? prev + (key === '' ? '' : delimiter + key) : key;

            if (!Array.isArray(value) && (type === '[object Object]' || type === '[object Array]') && Object.keys(value).length) {
                return step(value, newKey);
            }

            output[newKey] = value;
        });
    }

    step(target);

    return output;
}
